export default "__VITE_ASSET__K$onoCGU__"